/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.color] alternate color. The EU organic logo has a specific color scheme which should only be overridden in exceptional circumstances.
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function OrganicEUIcon({
  className,
  size = 'xsmall',
  color = '#97be0d',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color,
      }}
      className={className}
      {...rest}
      viewBox="50 -65 268 400"
    >
      <path fill="currentColor" d="M0 0h400v268H0z" />
      <g fill="#fff">
        <path d="M145.62 62.718c11.462.72 22.772 2.058 32.575 6.096-9.188 3.431-16.163 7.487-24.14 11.231l6.305-26.155c4.998 9.98 10.282 20.584 13.065 30.564-9.085-8.85-18.378-15.412-27.805-21.736zM195.933 60.062l25.855 9.377-20.233 9.513c1.96-8.544 4.141-17.197 6.93-26.155 2.936 11.04 5.958 22.437 8.064 33.063-6.555-9.286-13.68-17.275-20.616-25.798zM247.183 69.28c7.618 1.294 15.643.96 23.668.002-6.569 5.9-13.25 11.685-20.233 17.17a510.652 510.652 0 008.649-26.937l5.563 27.126c-5.518-4.71-11.661-10.495-17.647-17.36zM299.058 68.5c6.326-1.874 14.528-6.621 21.636-9.999a502.897 502.897 0 01-17.733 21.857c1.973-7.92 4.813-16.159 7.399-24.749 1.978 5.95 3.483 11.436 6.189 16.813-5.83-.331-11.661-1.519-17.491-3.923zM276.87 112.874c10.696-1.897 17.873-5.137 26.481-8.123-7.524 7.703-16.374 18.16-22.577 23.107l9.586-28.03c2.153 7.806 4.725 15.193 7.283 22.594-7.209-1.735-13.979-5.321-20.773-9.548zM250.776 148.03c9.691 2.38 18.302 4.078 28.512 3.283-6.376 6.145-14.248 10.047-22.264 13.732 2.664-7.852 5.3-15.764 7.555-24.436 3.361 8.833 6.221 19.23 10.095 26.032-9.564-5.671-16.783-12.123-23.898-18.611zM222.808 170.843c8.983 3.813 17.497 7.751 26.949 9.533-6.864 3-13.743 5.984-21.014 8.576 2.039-7.677 3.852-14.885 6.305-22.562 3.003 9.579 6.318 19.054 10.564 28.22-8.099-6.175-15.894-15.154-22.804-23.767zM186.089 184.905c9.191 2.656 18.383 6.631 27.574 10.94-7.671 3.204-15.166 6.935-22.421 11.388 3.088-9.516 6.457-19.229 8.493-28.499 2.843 11.02 6.585 22.569 9.314 33.845-5.545-6.621-15.323-19.178-22.96-27.674zM131.245 192.249c10.554-1.872 20.875-2.344 31.012-1.717-9.763 8.725-17.685 16.223-26.327 24.201l12.087-37.874c2.525 11.919 4.7 24.539 6.813 37.282-6.129-6.843-15.224-15.093-23.585-21.892zM112.026 97.093c11.885-3.585 23.447-3.775 34.919-2.81l-26.171 17.169c2.83-9.031 5.578-18.062 8.805-27.093 4.922 8.814 9.384 17.632 13.064 26.032-8.229-5.941-19.517-9.818-30.617-13.298zM89.058 147.874c11.587-5.899 23.33-10.378 34.918-10.467L95.93 164.733l11.305-37.093c4.226 9.755 8.39 20.493 10.564 30.251-8.898-4.231-18.196-7.845-28.742-10.017z" />
        <path d="M68.745 210.999c6.467-2.345 17.926-11.261 24.778-13.222 19.183-32.911 96.217-78.396 132.064-82.045 1.007-.102.89.609.041.857-37.59 10.968-100.701 45.345-124.309 82.693-9.078 14.361-12.641 16.4-24.451 29.982 3.747-14.406 7.58-28.84 12.555-43.655 4.563 11.264 7.837 22.958 11.189 34.625-9.326-5.036-20.459-7.946-31.867-9.235z" />
      </g>
    </svg>
  );
}
